import React from "react"

const Instagram = () => {
	return (
		<svg
			id="Combined_shape_2629"
			data-name="Combined shape 2629"
			width="17.001"
			height="17"
			viewBox="0 0 17.001 17"
		>
			<path
				id="Combined_shape_2629-2"
				data-name="Combined shape 2629"
				d="M14.823,17H2.181a2.1,2.1,0,0,1-1.538-.643A2.1,2.1,0,0,1,0,14.819V2.18A2.1,2.1,0,0,1,.643.643,2.1,2.1,0,0,1,2.181,0H14.823a2.111,2.111,0,0,1,1.538.643A2.105,2.105,0,0,1,17,2.18v12.64A2.189,2.189,0,0,1,14.823,17ZM1.893,7.194v7.172a.664.664,0,0,0,.676.675H14.4a.661.661,0,0,0,.478-.194.649.649,0,0,0,.2-.481V7.194H13.582a4.763,4.763,0,0,1,.221,1.45,4.931,4.931,0,0,1-.708,2.573,5.188,5.188,0,0,1-1.926,1.866,5.342,5.342,0,0,1-2.657.686,5.193,5.193,0,0,1-3.73-1.5A4.88,4.88,0,0,1,3.232,8.644a4.789,4.789,0,0,1,.222-1.45ZM8.512,5.157A3.359,3.359,0,0,0,6.1,6.125a3.236,3.236,0,0,0,0,4.682,3.359,3.359,0,0,0,2.407.968,3.369,3.369,0,0,0,2.418-.968,3.236,3.236,0,0,0,0-4.682A3.369,3.369,0,0,0,8.512,5.157Zm3.875-3.264a.728.728,0,0,0-.542.227.745.745,0,0,0-.221.536V4.482a.756.756,0,0,0,.763.764h1.926a.758.758,0,0,0,.764-.764V2.656a.746.746,0,0,0-.222-.536.728.728,0,0,0-.542-.227Z"
				fill="#88c8bc"
			/>
		</svg>
	)
}

export default Instagram
